import { type VariantProps, cva } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "@/lib/cn";

const badgeVariants = cva(
  "inline-flex items-center justify-center rounded-md border px-2.5 py-0.5 text-badgeLabel transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        primary: "border-transparent bg-primary-fill text-primary-on-fill",
        secondary:
          "border-transparent bg-secondary-fill text-secondary-on-fill",
        secondaryMuted:
          "border-transparent bg-secondary-muted-fill text-secondary-on-muted-fill",
        destructive: "border-transparent bg-error-fill text-error-on-fill", // deprecated
        destructiveMuted: // deprecated
          "border-transparent bg-error-muted-fill text-error-on-muted-fill",
        error: "border-transparent bg-error-fill text-error-on-fill",
        errorMuted:
          "border-transparent bg-error-muted-fill text-error-on-muted-fill",
        neutralMuted:
          "border-transparent bg-neutral-gray-light-4 text-neutral-on-muted-fill",
        primaryMuted:
          "border-transparent bg-primary-muted-fill text-primary-on-muted-fill",
        mutedSuccess:
          "border-transparent bg-success-muted-fill text-success-on-muted-fill",
        mutedWarning:
          "border-transparent bg-warning-muted-fill text-warning-on-muted-fill",
        outline: "border-neutral-border text-neutral-on-fill",
        noFill: "border-transparent text-neutral-on-fill",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];
interface BadgeProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
